import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const NotificationsEmptyState = ({ t, onCreateNew }) => {
  return (
    <div className="notifications-empty-state">
      <div className="notifications-empty-illustration">
        <div className="notifications-empty-icon">
          <span className="material-symbols-outlined">notifications</span>
        </div>
        <div className="notifications-empty-ripple notifications-empty-ripple-1" />
        <div className="notifications-empty-ripple notifications-empty-ripple-2" />
        <div className="notifications-empty-ripple notifications-empty-ripple-3" />
      </div>
      <h3 className="notifications-empty-title">
        {t('notificationsPage:emptyStateTitle')}
      </h3>
      <p className="notifications-empty-description">
        {t('notificationsPage:emptyStateDescription')}
      </p>
      {onCreateNew && (
        <button
          type="button"
          className="notifications-empty-cta"
          onClick={onCreateNew}
        >
          <span className="material-symbols-outlined">add</span>
          {t('notificationsPage:addNotificationButton')}
        </button>
      )}
    </div>
  );
};

NotificationsEmptyState.propTypes = {
  t: PropTypes.func.isRequired,
  onCreateNew: PropTypes.func,
};

NotificationsEmptyState.defaultProps = {
  onCreateNew: null,
};

export default NotificationsEmptyState;
